import { TipoDireccion } from '../tipo/tipo-direccion.class';
export class DireccionProspecto {
    tipoDireccion: TipoDireccion;
    direccion: String;
    municipio: String;
    numeroTelefono: String;
    esCorrespondencia: String;
    email: String;
    esEmailCorrespondencia: String;

    constructor(tipoDireccion: TipoDireccion, direccion: String, municipio: String, numeroTelefono: String,
        esCorrespondencia: String, email: String, esEmailCorrespondencia: String) {
        this.tipoDireccion = tipoDireccion;
        this.direccion = direccion;
        this.municipio = municipio;
        this.numeroTelefono = numeroTelefono;
        this.esCorrespondencia = esCorrespondencia;
        this.email = email;
        this.esEmailCorrespondencia = esEmailCorrespondencia;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/prospecto/direccion-prospecto.class.ts